import { render, staticRenderFns } from "./Payment3D.vue?vue&type=template&id=1159dfe0&scoped=true&"
import script from "./Payment3D.vue?vue&type=script&lang=js&"
export * from "./Payment3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159dfe0",
  null
  
)

export default component.exports